import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import AnimateSection from '@/components/base/AnimateSection';

export default function CategoryNavSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <AnimateSection>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {t('home.categoryNav')}
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              {t('home.categoryNavDesc')}
            </p>
          </div>
        </AnimateSection>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <AnimateSection key={cat.id} delay={index * 80} animation="animate-scale-in">
              <Link
                to={`/category/${cat.slug}`}
                className="group relative bg-background-100 rounded-xl p-5 md:p-6 hover:bg-primary-50 transition-all duration-300 cursor-pointer overflow-hidden block h-full"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 group-hover:bg-primary-200 group-hover:scale-110 transition-all duration-300 mb-3 md:mb-4">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-300 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
                <div className="absolute bottom-3 right-4 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                  <i className="ri-arrow-right-line text-primary-500 text-sm"></i>
                </div>
              </Link>
            </AnimateSection>
          ))}
        </div>

        <AnimateSection delay={300}>
          <div className="text-center mt-8 md:mt-10">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('home.allCategories')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </AnimateSection>
      </div>
    </section>
  );
}